import React from 'react';

import { SECTIONS, COMPONENTS, CATEGORIES } from 'components/Globals/Analytics/constants';
import EntitySuggestions from 'components/Globals/EntitySuggestions';

import useNavigate from 'utils/hooks/useNavigate';

import { ENTITY_TYPES, ROUTE_RESERVED_KEYWORDS } from 'operabase-router/constants';

import classes from './FeaturedTrending.module.scss';

const trackingData = {
  section: SECTIONS.POPULAR_TODAY,
  component: COMPONENTS.ARTIST_CARD,
  category: CATEGORIES.RECOMMENDED,
};

const FeaturedTrending = () => {
  const navigate = useNavigate();

  return (
    <EntitySuggestions
      entityType={ENTITY_TYPES.PROFILE}
      isHomepage
      trackingData={trackingData}
      sectionProps={{
        linkProps: navigate.getLinkProps({ baseRoute: ROUTE_RESERVED_KEYWORDS.artists }),
      }}
      styles={{
        leftBoxIcon: classes.leftBoxIcon,
        horizontalScroll: classes.horizontalScroll,
        header: classes.header,
      }}
    />
  );
};

export default FeaturedTrending;
